/**
 * Acronyms and short codes kept intact when sentence-casing role names.
 * Matched case-insensitively against whole words / hyphen segments.
 */
const PRESERVE_TOKENS = new Set(['UI', 'UX', 'SEO', 'AI', '3D', '2D', 'DJ']);

const normalizePreserved = (token) => {
  const upper = token.toUpperCase();
  for (const preserved of PRESERVE_TOKENS) {
    if (preserved.toUpperCase() === upper) {
      return preserved;
    }
  }
  return null;
};

const sentenceCaseSegment = (segment, isFirstSegment) => {
  const preserved = normalizePreserved(segment);
  if (preserved) {
    return preserved;
  }

  if (!segment) {
    return segment;
  }

  if (isFirstSegment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
  }

  return segment.toLowerCase();
};

const sentenceCaseWord = (word, isFirstWord) => {
  if (!word.includes('-')) {
    return sentenceCaseSegment(word, isFirstWord);
  }

  return word
    .split('-')
    .map((segment, index) =>
      sentenceCaseSegment(segment, isFirstWord && index === 0)
    )
    .join('-');
};

/**
 * Sentence-case a role (or similar) display name for jobs SEO copy.
 * First word is capitalized; later words are lowercased; known acronyms
 * (UI, UX, SEO, AI, 3D, 2D, DJ) stay intact.
 *
 * e.g. "Web Developer" → "Web developer"
 *      "UI Designer" → "UI designer"
 *      "Back-End Developer" → "Back-end developer"
 */
export default function toSentenceCase(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const trimmed = text.trim();
  if (!trimmed) {
    return '';
  }

  return trimmed
    .split(/\s+/)
    .map((word, index) => sentenceCaseWord(word, index === 0))
    .join(' ');
}
